(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/react/debugger.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/react/debugger.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef,
  useMemo = _React.useMemo;
function findJotai() {
  const stack = [svs.lyckoplatsen];
  const visited = new Set();
  const results = [];
  while (stack.length) {
    const obj = stack.pop();
    visited.add(obj);
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (key === 'jotai') {
          results.push(obj[key]);
        } else if (typeof obj[key] === 'object' && obj[key] !== null && !visited.has(obj[key])) {
          stack.push(obj[key]);
        }
      }
    }
  }
  return results;
}
function formatAtoms(data) {
  const formattedData = {
    atoms: []
  };
  data.forEach(entry => {
    if (entry.atoms) {
      Object.keys(entry.atoms).forEach(atomKey => {
        formattedData.atoms.push({
          [atomKey]: entry.atoms[atomKey]
        });
      });
    }
  });
  return formattedData;
}
const Debugger = () => {
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    highlightedAtoms = _useState4[0],
    setHighlightedAtoms = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showData = _useState6[0],
    setShowData = _useState6[1];
  const prevAtomValuesRef = useRef([]);
  const allJotai = useMemo(() => findJotai(), []);
  const formattedAtoms = useMemo(() => formatAtoms(allJotai), [allJotai]);
  const atomList = useMemo(() => formattedAtoms.atoms.map(atomObject => {
    const atomKey = Object.keys(atomObject)[0];
    return {
      atomKey,
      atom: atomObject[atomKey]
    };
  }), [formattedAtoms]);
  const atomValues = atomList.map(_ref => {
    let atomKey = _ref.atomKey,
      atom = _ref.atom;
    const atomValue = useAtomValue(atom);
    return {
      atomKey,
      atomValue
    };
  });
  useEffect(() => {
    const currentValues = atomValues.map(_ref2 => {
      let atomValue = _ref2.atomValue;
      return atomValue;
    });
    currentValues.forEach((currentValue, index) => {
      const prevValue = prevAtomValuesRef.current[index];
      if (JSON.stringify(currentValue) !== JSON.stringify(prevValue)) {
        setHighlightedAtoms(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [index]: true
        }));
        setTimeout(() => {
          setHighlightedAtoms(prev => _objectSpread(_objectSpread({}, prev), {}, {
            [index]: false
          }));
        }, 2000);
      }
    });
    prevAtomValuesRef.current = currentValues;
  }, [atomValues]);
  const toggleExpand = index => {
    setIsExpanded(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [index]: !prev[index]
    }));
  };
  const renderAtomValue = (atomValue, atomIndex) => {
    if (Array.isArray(atomValue) && atomValue.length > 0) {
      return atomValue.map((item, itemIndex) => React.createElement("div", {
        className: "margin-bottom",
        key: itemIndex
      }, React.createElement("div", {
        className: "pointer",
        onClick: () => toggleExpand("".concat(atomIndex, "-").concat(itemIndex))
      }, isExpanded["".concat(atomIndex, "-").concat(itemIndex)] ? '▼' : '▶', " ", itemIndex), isExpanded["".concat(atomIndex, "-").concat(itemIndex)] && React.createElement("div", {
        className: "padding-left-1"
      }, typeof item === 'object' ? React.createElement("pre", null, JSON.stringify(item, null, 2)) : React.createElement("span", null, item))));
    }
    if (typeof atomValue === 'object' && atomValue !== null) {
      return React.createElement("pre", null, JSON.stringify(atomValue, null, 2));
    }
    return React.createElement("span", null, String(atomValue));
  };
  return React.createElement("div", {
    className: "lp-debugger-container"
  }, React.createElement("div", {
    className: "debugger-button pointer",
    type: "button",
    onClick: () => setShowData(prev => !prev)
  }, "\uD83D\uDC7B"), showData && React.createElement("div", {
    className: "lp-debugger-list"
  }, atomValues.map((_ref3, atomIndex) => {
    let atomKey = _ref3.atomKey,
      atomValue = _ref3.atomValue;
    const classNames = ['pointer bold'];
    const noAtomValue = !atomValue || Array.isArray(atomValue) && !atomValue.length;
    if (highlightedAtoms[atomIndex]) {
      classNames.push('highlight-green');
    }
    if (noAtomValue) {
      classNames.push('highlight-orange');
    }
    return React.createElement("div", {
      className: "margin-bottom-1",
      key: atomIndex
    }, React.createElement("div", {
      className: classNames.join(' '),
      onClick: () => toggleExpand(atomIndex)
    }, isExpanded[atomIndex] ? '▼' : '▶', " ", atomKey), isExpanded[atomIndex] && React.createElement("div", {
      className: "padding-left-1 ".concat(noAtomValue ? 'highlight-orange' : '')
    }, renderAtomValue(atomValue, atomIndex)));
  })));
};
Object.assign(svs.lyckoplatsen.react, {
  Debugger
});

 })(window);